module.exports = __webpack_public_path__ + "images/overlay_close_btn.c45faae9.png";